import React, { useContext, useEffect, useRef } from "react";
import TableAutoComponent from "../../components/complex/crud/TableAutoComponent";
import FilterComponent from "../../components/complex/crud/FilterComponent";
import generateFilterConfigs from "../../utils/FilterConfigGenerator";
import generateTableConfigs from "../../utils/TableConfigGenerator";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Paginator } from "primereact/paginator";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

import useSelectorDialogControl from "../../custom_hooks/complex/useSelectorDialogControl";
import UiContext from "../../store/ui-context";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputTextarea } from "primereact/inputtextarea";

const apiName = "masterdata/toko";
const orderBy = "nama_toko";
const orderMethod = "ASC";
const additionalParams = {};

const customColumns = [];

const configs = [
  // add_configs
  {
    name: "Nama",
    field: "nama_toko",
    type: "text_plain",
    table: true,
    filter: true,
  },
  // {
  //   name: "IDX",
  //   field: "index",
  //   type: "number_plain",
  //   table: true,
  //   filter: true,
  // },
];

const filterConfigs = generateFilterConfigs(configs);
const tableConfigs = generateTableConfigs(configs);

const onReloadSuccess = (data) => {
  const inputElement = document.querySelector("#filterInput");
  if (inputElement) {
    inputElement.focus();
  }
};

const TokoSelectorDialog = (props) => {
  const single = props.single ?? true;
  const { title, onConfirm } = props;
  const uiContext = useContext(UiContext);

  const {
    toast,
    listData,
    paging,
    loading,
    setListData,
    selectedRows,
    setSelectedRows,
    refineValue,
    reloadListData,
    handleOnFilter,
    handleOnPage,
    handleSelectionChange,
    // API
    requestGet,
    requestGetOne,
    requestPost,
    requestDelete,
  } = useSelectorDialogControl({
    apiName,
    orderBy,
    orderMethod,
    additionalParams,
    visible: props.visible,
    onReloadSuccess,
    take: 30,
    additionalFilter: props.additionalFilter,
  });

  const [filterTextNama, setFilterTextNama] = React.useState("");

  useEffect(() => {
    if (props.visible) {
      setFilterTextNama("");
    }
  }, []);

  const handleOnConfirmFilterTextNama = () => {
    const filterText = filterTextNama.toLowerCase();

    handleOnFilter({
      alias: {},
      compare_method: "or",
      filter: [
        {
          config: {
            name: "Nama",
            field: "nama_toko",
            type: "text_plain",
            table: true,
            filter: true,
            value: "nama_toko",
          },
          field: "nama_toko",
          value: {
            operator: "none",
            value: [filterText],
          },
        },
      ],
    });
  };

  const dialogFooter = (
    <div className="col-center-center w-100">
      <Paginator
        first={paging.take * (paging.page - 1)}
        rows={paging.take}
        totalRecords={paging.total}
        rowsPerPageOptions={[5, 8, 10, 20, 50]}
        onPageChange={handleOnPage}
        template={{
          layout: "PrevPageLink PageLinks NextPageLink",
        }}
        pt={{}}
      />
      <div className="row-between-end w-100">
        <div />
        <div className="row-end-end">
          <Button
            label="Cancel"
            icon="pi pi-times"
            outlined
            loading={loading}
            onClick={props.onHide}
          />
          <Button
            label="Pilih"
            icon="pi pi-check"
            loading={loading}
            onClick={(e) => {
              let refinedValue = refineValue(selectedRows);
              refinedValue = [refinedValue];
              onConfirm(e, refinedValue);
            }}
          />
        </div>
      </div>
    </div>
  );

  // const CustomSmallFilter = () => {
  //   return (
  //   );
  // };

  return (
    <Dialog
      visible={props.visible}
      header={title}
      modal
      className={`p-fluid w-[44rem] min-h-[30rem]`}
      footer={dialogFooter}
      onHide={props.onHide}
      contentStyle={{ paddingBottom: "0px" }}
    >
      <div className={`col-start-start w-100 gap-3 pt-1`}>
        <div className="row-start-center gap-2 w-full">
          <IconField iconPosition="left">
            <InputIcon className="pi pi-search"> </InputIcon>
            <InputText
              id="filterInput"
              className="!pl-10"
              placeholder="Cari Nama..."
              value={filterTextNama}
              autoFocus={true}
              onChange={(e) => setFilterTextNama(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleOnConfirmFilterTextNama();
                }
              }}
            />
          </IconField>
          <Button
            className="max-h-[2.5rem]"
            icon="pi pi-refresh"
            onClick={handleOnConfirmFilterTextNama}
          />
        </div>
        <div className={`col-center-center w-100 gap-2`}>
          <DataTable
            className="w-full"
            value={listData}
            loading={loading}
            // selectionMode={"radiobutton"}
            selection={selectedRows}
            onSelectionChange={(e) => setSelectedRows(e.value)}
            stripedRows
            dataKey="id"
            showGridlines
            size="small"
          >
            <Column
              selectionMode="single"
              headerStyle={{ width: "2rem" }}
              className="!py-2"
            />
            <Column
              field="nama_toko"
              header="NAMA TOKO"
              className="!py-2"
              headerClassName="!py-2"
            />
            {/* <Column
              field="index"
              header="SORT"
              className="text-sm !py-2"
              headerClassName="!py-2"
            /> */}
          </DataTable>
        </div>
      </div>
    </Dialog>
  );
};

export default TokoSelectorDialog;
